<template>
	<div class="multiple-display" v-show="!isFetching" id=multipleDisplay :class="{'disabled': isFetching}">
		<transition name="fade">
			<div v-if="isShowButtonReset" @click="resetPane" class="floating-rebuild-cache-btn" v-tooltip="$t('Reset Pane')">
				<i class="material-icons mt-1 pt-1">refresh</i>
			</div>
		</transition>
		<!-- 1 -->
		<div v-if="filteredDisplayRundown.length === 1" class="stream-preview wrapper-multi" :style="streamPreviewStyle(filteredDisplayRundown[0].displaySize)">
			<div class="stream-preview-wrapper" :style="streamWrapperStyle(filteredDisplayRundown[0])">
				<iframe
					class="iframe-stream-preview"
					style="pointer-events: none; height: 80vh"
					frameBorder="0"
					v-show="!isFetching"
					:src="liveUrl(filteredDisplayRundown[0])">
				</iframe>
			</div>
			<div class="z-index-99 name-multi-view text-right">
				<h5 class="truncate-rd-info">{{filteredDisplayRundown[0] && filteredDisplayRundown[0].displaySize && filteredDisplayRundown[0].name ? filteredDisplayRundown[0].name : ''}}</h5>
			</div>
		</div>
		<!-- 1-2 -->
		<Split v-if="filteredDisplayRundown.length > 1 && filteredDisplayRundown.length <= 2" style="height: 100vh;" @onDrag="onDragEnd2" ref="mySplit2">
			<template v-for="(item, index) in filteredItems(0, 2)">
				<SplitArea :size="50" :minSize="1" :key="item.id" style="overflow-y: hidden; position: relative;" :style="{ paddingTop: centerVertically(item, 'row1', index)+'px' }">
					<div class="stream-preview test-iframe" :style="streamPreviewStyle(item.displaySize)">
						<div class="stream-preview-wrapper" :style="streamWrapperStyle(item, index)">
							<iframe
								class="iframe-stream-preview"
								style="pointer-events: none;"
								frameBorder="0"
								v-show="!isFetching"
								:src="liveUrl(item)">
							</iframe>
						</div>
					</div>
					<div class="z-index-99 name-multi-view text-right">
						<h5 class="truncate-rd-info">{{item && item.displaySize && item.name ? item.name : ''}}</h5>
					</div>
				</SplitArea>
			</template>
		</Split>
		<!-- 1-4 -->
		<Split v-if="filteredDisplayRundown.length > 2 && filteredDisplayRundown.length <= 4" style="height: 100vh;" direction='vertical' @onDrag="onDragEnd4Vertical" ref="mySplit4">
			<SplitArea :minSize="1">
				<Split @onDrag="onDragEnd4Horizontal" ref="mySplit41">
					<template v-for="(item, index) in filteredItems(0, 2)">
						<SplitArea :size="50" :minSize="1" :key="item.id" style="overflow-y: hidden; position: relative;" :style="{ paddingTop: centerVertically(item, 'row1', index)+'px' }">
							<div class="stream-preview wrapper-multi" :style="streamPreviewStyle(item.displaySize,  index, 'row1')">
								<div class="stream-preview-wrapper" :style="streamWrapperStyle(item, index, 'row1')">
									<iframe
										class="iframe-stream-preview"
										style="pointer-events: none;"
										frameBorder="0"
										v-show="!isFetching"
										:src="liveUrl(item)">
									</iframe>
								</div>
							</div>
							<div class="z-index-99 name-multi-view text-right">
								<h5 class="truncate-rd-info">{{item && item.displaySize && item.name ? item.name : ''}}</h5>
							</div>
						</SplitArea>
					</template>
				</Split>
			</SplitArea>
			<SplitArea :minSize="1">
				<Split @onDrag="onDragEnd42Horizontal"  ref="mySplit42">
					<template v-for="(item, index) in filteredItems(2, 4)">
						<SplitArea :size="50" :minSize="1" :key="item.id" style="overflow-y: hidden; position: relative;"  :style="{ paddingTop: centerVertically(item, 'row2', index)+'px' }">
							<div class="stream-preview wrapper-multi" :style="streamPreviewStyle(item.displaySize,  index, 'row2')">
								<div class="stream-preview-wrapper" :style="streamWrapperStyle(item, index, 'row2')">
									<iframe
										class="iframe-stream-preview"
										style="pointer-events: none;"
										frameBorder="0"
										v-show="!isFetching"
										:src="liveUrl(item)">
									</iframe>
								</div>
							</div>
							<div class="z-index-99 name-multi-view text-right">
								<h5 class="truncate-rd-info">{{item && item.displaySize && item.name ? item.name : ''}}</h5>
							</div>
						</SplitArea>
					</template>
					<SplitArea :size="50" :minSize="1" v-if="filteredDisplayRundown.length === 3">
					</SplitArea>
				</Split>
			</SplitArea>
		</Split>
		<!-- 6 item -->
		<Split v-if="filteredDisplayRundown.length > 4 && filteredDisplayRundown.length <= 6" style="height: 100vh;" direction='vertical' @onDrag="onDragEnd6Vertical" ref="mySplit6">
			<SplitArea :size="33.3" :minSize="1">
				<Split @onDrag="onDragEnd6Horizontal" ref="mySplit61">
					<template v-for="(item, index) in filteredItems(0, 3)">
						<SplitArea :size="33.3" :minSize="1" :key="item.id" style="overflow-y: hidden; position: relative;" :style="{ paddingTop: centerVertically(item, 'row1', index)+'px' }">
							<div class="stream-preview wrapper-multi" :style="streamPreviewStyle(item.displaySize, index, 'row1')">
								<div class="stream-preview-wrapper" :style="streamWrapperStyle(item, index, 'row1')">
									<iframe
										class="iframe-stream-preview"
										style="pointer-events: none;"
										frameBorder="0"
										v-show="!isFetching"
										:src="liveUrl(item)">
									</iframe>
								</div>
							</div>
							<div class="z-index-99 name-multi-view text-right">
								<h5 class="truncate-rd-info">{{item && item.displaySize && item.name ? item.name : ''}}</h5>
							</div>
						</SplitArea>
					</template>
				</Split>
			</SplitArea>
			<SplitArea :size="33" :minSize="1">
				<Split @onDrag="onDragEnd62Horizontal" ref="mySplit62">
					<template v-for="(item, index) in filteredItems(3, 6)">
						<SplitArea :size="33.3" :minSize="1" :key="item.id" style="overflow-y: hidden; position: relative;" :style="{ paddingTop: centerVertically(item, 'row2', index)+'px' }">
							<div class="stream-preview wrapper-multi" :style="streamPreviewStyle(item.displaySize, index, 'row2')">
								<div class="stream-preview-wrapper" :style="streamWrapperStyle(item, index, 'row2')">
									<iframe
										class="iframe-stream-preview"
										style="pointer-events: none;"
										frameBorder="0"
										v-show="!isFetching"
										:src="liveUrl(item)">
									</iframe>
								</div>
							</div>
							<div class="z-index-99 name-multi-view text-right">
								<h5 class="truncate-rd-info">{{item && item.displaySize && item.name ? item.name : ''}}</h5>
							</div>
						</SplitArea>
					</template>
					<SplitArea :size="33.3" :minSize="1" v-if="filteredDisplayRundown.length === 5">
					</SplitArea>
				</Split>
			</SplitArea>
			<SplitArea :size="33" :minSize="1">
			</SplitArea>
		</Split>
		<!-- 9 item -->
		<Split v-if="filteredDisplayRundown.length > 6 && filteredDisplayRundown.length <= 9" style="height: 100vh;" direction='vertical' @onDrag="onDragEnd9Vertical" ref="mySplit9">
			<SplitArea :size="33.3" :minSize="1">
				<Split @onDrag="onDragEnd9Horizontal" ref="mySplit91">
					<template v-for="(item, index) in filteredItems(0, 3)">
						<SplitArea :size="33.3" :minSize="1" :key="item.id" style="overflow-y: hidden; position: relative; width: 100%" :style="{ paddingTop: centerVertically(item, 'row1', index)+'px' }">
							<div class="stream-preview wrapper-multi" :style="streamPreviewStyle(item.displaySize,  index, 'row1')">
								<div class="stream-preview-wrapper" :style="streamWrapperStyle(item,  index, 'row1')" style="overflow-y: hidden; position: relative; width: 100%">
									<iframe
										class="iframe-stream-preview"
										style="pointer-events: none;"
										frameBorder="0"
										v-show="!isFetching"
										:src="liveUrl(item)">
									</iframe>
								</div>
							</div>
							<div class="z-index-99 name-multi-view text-right">
								<h5 class="truncate-rd-info">{{item && item.displaySize && item.name ? item.name : ''}}</h5>
							</div>
						</SplitArea>
					</template>
				</Split>
			</SplitArea>
			<SplitArea :size="33" :minSize="1">
				<Split @onDrag="onDragEnd92Horizontal" ref="mySplit92">
					<template v-for="(item, index) in filteredItems(3, 6)">
						<SplitArea :size="33.3" :minSize="1" :key="item.id" style="overflow-y: hidden; position: relative;" :style="{ paddingTop: centerVertically(item, 'row2', index)+'px' }">
							<div class="stream-preview wrapper-multi" :style="streamPreviewStyle(item.displaySize,  index, 'row2')">
								<div class="stream-preview-wrapper" :style="streamWrapperStyle(item,  index, 'row2')">
									<iframe
										class="iframe-stream-preview"
										style="pointer-events: none;"
										frameBorder="0"
										v-show="!isFetching"
										:src="liveUrl(item)">
									</iframe>
								</div>
							</div>
							<div class="z-index-99 name-multi-view text-right">
								<h5 class="truncate-rd-info">{{item && item.displaySize && item.name ? item.name : ''}}</h5>
							</div>
						</SplitArea>
					</template>
				</Split>
			</SplitArea>
			<SplitArea :size="33" :minSize="1">
				<Split @onDrag="onDragEnd93Horizontal" ref="mySplit93">
					<template v-for="(item, index) in filteredItems(6, 9)">
						<SplitArea :size="33.3" :minSize="1" :key="item.id" style="overflow-y: hidden; position: relative;" :style="{ paddingTop: centerVertically(item, 'row3', index)+'px' }">
							<div class="stream-preview wrapper-multi" :style="streamPreviewStyle(item.displaySize, index, 'row3')">
								<div class="stream-preview-wrapper" :style="streamWrapperStyle(item, index, 'row3')">
									<iframe
										class="iframe-stream-preview"
										style="pointer-events: none;"
										frameBorder="0"
										v-show="!isFetching"
										:src="liveUrl(item)">
									</iframe>
								</div>
							</div>
							<div class="z-index-99 name-multi-view text-right">
								<h5 class="truncate-rd-info">{{item && item.displaySize && item.name ? item.name : ''}}</h5>
							</div>
						</SplitArea>
					</template>
					<SplitArea :size="33.3" :minSize="1" v-if="filteredDisplayRundown.length === 7">
					</SplitArea>
					<SplitArea :size="33.3" :minSize="1" v-if="filteredDisplayRundown.length === 7">
					</SplitArea>
					<SplitArea :size="33.3" :minSize="1" v-if="filteredDisplayRundown.length === 8">
					</SplitArea>
				</Split>
			</SplitArea>
		</Split>
	</div>
</template>

<script>
import { mapActions } from 'vuex';
import {
	getAxiosErrorMessage,
} from '@/lib/helper';
import displaysApi from '@/api/displays';

export default {
	name: 'MultiviewOutputDisplay',
	data() {
		return {
			isFetching: false,
			items: [],
			resultPreviewWidth: 0,
			resultPreviewHeight: 0,
			spaceLeft: 0,
			arrayDisplayRatio2: [],
			// 4 screen
			arrayDisplayRatio4Vertical: [],
			arrayDisplayRatio4Horizontal: [],
			arrayDisplayRatio42Horizontal: [],
			// 6 screen
			arrayDisplayRatio6Vertical: [],
			arrayDisplayRatio6Horizontal: [],
			arrayDisplayRatio62Horizontal: [],
			// 9 screen
			arrayDisplayRatio9Vertical: [],
			arrayDisplayRatio9Horizontal: [],
			arrayDisplayRatio92Horizontal: [],
			arrayDisplayRatio93Horizontal: [],
			// button reset
			isShowButtonReset: false,
			timer: null,
		};
	},
	components: {
	},
	methods: {
		...mapActions({
			setDrawerVisible: 'setDrawerVisible',
		}),
		fetchDisplay(reset) {
			this.isFetching = true;
			if (reset) {
				this.items = [];
			}
			const params = {
				page: 1,
				limit: 9,
				order_by: 'created_at',
				sort_by: 'asc',
				is_have_rundown: true,
				user_id: this.ownMultipviewUserId,
			};
			const callback = (response) => {
				const items = response.data;
				this.items = items;
				this.isFetching = false;
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Outputs',
					text: message,
				});
				this.isFetching = false;
			};
			displaysApi.getList(params, callback, errorCallback);
		},
		liveUrl(item) {
			const appUrl = process.env.VUE_APP_URL;
			const slug = item && item.rundown && item.rundown.slug ? item.rundown.slug : '';
			return `${appUrl}/displays/live/${slug}/${item.id}?rundown_id=${item.rundown_id}`;
		},
		streamWrapperStyle(size, index, row) {
			// width
			const defaultWidth = 1920;
			const displayWidth = size ? parseInt(size.displaySize.width) : defaultWidth;
			// height
			const defaultHeight = 1080;
			const displayHeight = size ? parseInt(size.displaySize.height) : defaultHeight;
			// style
			const displayWidthResult = displayWidth;
			const displayHeightResult = displayHeight;
			let transformScale = 0; // default scale
			// condition dividing screen for aspect ratio
			let itemsLength = this.filteredDisplayRundown.length === 3 ? this.filteredDisplayRundown.length - 1 : this.filteredDisplayRundown.length;
			if (this.filteredDisplayRundown.length === 4) itemsLength = 2;
			if (this.filteredDisplayRundown.length > 4 && this.filteredDisplayRundown.length <= 9) itemsLength = 3;
			let countingScreen = window.innerHeight / itemsLength;
			transformScale = countingScreen / displayHeight;
			if (this.filteredDisplayRundown.length === 2) {
				itemsLength = 2;
				countingScreen = window.innerWidth / itemsLength;
				transformScale = countingScreen / displayWidth;
			}
			// make responsive base on screen and base on panel resized
			// 2 screen
			if (this.arrayDisplayRatio2 && this.arrayDisplayRatio2.length > 0) {
				const calculatewindow = window.innerWidth * (this.arrayDisplayRatio2[index] ? this.arrayDisplayRatio2[index] : 50) / 100;
				transformScale = calculatewindow / displayWidth;
			}
			// 4 screen
			if ((this.arrayDisplayRatio4Vertical && this.arrayDisplayRatio4Vertical.length > 0)
				|| (this.arrayDisplayRatio4Horizontal && this.arrayDisplayRatio4Horizontal.length > 0)
				|| (this.arrayDisplayRatio42Horizontal && this.arrayDisplayRatio42Horizontal.length > 0)) {
				if (row === 'row1') {
					const calculatewindowHeight = window.innerHeight * (this.arrayDisplayRatio4Vertical[0] ? this.arrayDisplayRatio4Vertical[0] : 50) / 100;
					const calculatewindowWidth = window.innerWidth * (this.arrayDisplayRatio4Horizontal[index] ? this.arrayDisplayRatio4Horizontal[index] : 50) / 100;
					transformScale = Math.min(calculatewindowWidth / displayWidth, calculatewindowHeight / displayHeight);
				}
				if (row === 'row2') {
					const calculatewindowHeight = window.innerHeight * (this.arrayDisplayRatio4Vertical[1] ? this.arrayDisplayRatio4Vertical[1] : 50) / 100;
					const calculatewindowWidth = window.innerWidth * (this.arrayDisplayRatio42Horizontal[index] ? this.arrayDisplayRatio42Horizontal[index] : 50) / 100;
					transformScale = Math.min(calculatewindowWidth / displayWidth, calculatewindowHeight / displayHeight);
				}
			}
			// 6 screen
			if ((this.arrayDisplayRatio6Vertical && this.arrayDisplayRatio6Vertical.length > 0)
				|| (this.arrayDisplayRatio6Horizontal && this.arrayDisplayRatio6Horizontal.length > 0)
				|| (this.arrayDisplayRatio62Horizontal && this.arrayDisplayRatio62Horizontal.length > 0)) {
				if (row === 'row1') {
					const calculatewindowHeight = window.innerHeight * (this.arrayDisplayRatio6Vertical[0] ? this.arrayDisplayRatio6Vertical[0] : 33.3) / 100;
					const calculatewindowWidth = window.innerWidth * (this.arrayDisplayRatio6Horizontal[index] ? this.arrayDisplayRatio6Horizontal[index] : 33.3) / 100;
					transformScale = Math.min(calculatewindowWidth / displayWidth, calculatewindowHeight / displayHeight);
				}
				if (row === 'row2') {
					const calculatewindowHeight = window.innerHeight * (this.arrayDisplayRatio6Vertical[1] ? this.arrayDisplayRatio6Vertical[1] : 33.3) / 100;
					const calculatewindowWidth = window.innerWidth * (this.arrayDisplayRatio62Horizontal[index] ? this.arrayDisplayRatio62Horizontal[index] : 33.3) / 100;
					transformScale = Math.min(calculatewindowWidth / displayWidth, calculatewindowHeight / displayHeight);
				}
			}
			// 9 screen
			if ((this.arrayDisplayRatio9Vertical && this.arrayDisplayRatio9Vertical.length > 0) || (this.arrayDisplayRatio9Horizontal && this.arrayDisplayRatio9Horizontal.length > 0)
				|| (this.arrayDisplayRatio92Horizontal && this.arrayDisplayRatio92Horizontal.length > 0)
				|| (this.arrayDisplayRatio93Horizontal && this.arrayDisplayRatio93Horizontal.length > 0)) {
				if (row === 'row1') {
					const calculatewindowHeight = window.innerHeight * (this.arrayDisplayRatio9Vertical[0] ? this.arrayDisplayRatio9Vertical[0] : 33.3) / 100;
					const calculatewindowWidth = window.innerWidth * (this.arrayDisplayRatio9Horizontal[index] ? this.arrayDisplayRatio9Horizontal[index] : 33.3) / 100;
					transformScale = Math.min(calculatewindowWidth / displayWidth, calculatewindowHeight / displayHeight);
				}
				if (row === 'row2') {
					const calculatewindowHeight = window.innerHeight * (this.arrayDisplayRatio9Vertical[1] ? this.arrayDisplayRatio9Vertical[1] : 33.3) / 100;
					const calculatewindowWidth = window.innerWidth * (this.arrayDisplayRatio92Horizontal[index] ? this.arrayDisplayRatio92Horizontal[index] : 33.3) / 100;
					transformScale = Math.min(calculatewindowWidth / displayWidth, calculatewindowHeight / displayHeight);
				}
				if (row === 'row3') {
					const calculatewindowHeight = window.innerHeight * (this.arrayDisplayRatio9Vertical[2] ? this.arrayDisplayRatio9Vertical[2] : 33.3) / 100;
					const calculatewindowWidth = window.innerWidth * (this.arrayDisplayRatio93Horizontal[index] ? this.arrayDisplayRatio93Horizontal[index] : 33.3) / 100;
					transformScale = Math.min(calculatewindowWidth / displayWidth, calculatewindowHeight / displayHeight);
				}
			}
			// get bg color
			const backgroundColor = size && size.background_color && size.background_color !== '' ? size.background_color : '#000';
			// implement style
			const style = {
				width: `${displayWidthResult}px`,
				height: `${displayHeightResult}px`,
				transform: `scale(${transformScale})`,
				backgroundColor,
			};
			return style;
		},
		streamPreviewStyle(size, index, row) {
			// width
			const defaultWidth = 1920;
			const displayWidth = size ? parseInt(size.width) : defaultWidth;
			// height
			const defaultHeight = 1080;
			const displayHeight = size ? parseInt(size.height) : defaultHeight;
			const ratio = displayHeight / displayWidth;
			// preview height
			const viewportHeight = window.innerHeight;
			const mainHeight = viewportHeight;
			// condition dividing screen for aspect ratio
			let itemsLength = this.filteredDisplayRundown.length === 3 ? this.filteredDisplayRundown.length - 1 : this.filteredDisplayRundown.length;
			if (this.filteredDisplayRundown.length === 4) itemsLength = 2;
			if (this.filteredDisplayRundown.length > 4 && this.filteredDisplayRundown.length <= 9) itemsLength = 3;
			if (this.filteredDisplayRundown.length === 2) {
				itemsLength = 2;
			}
			let previewHeight = mainHeight / itemsLength;
			// 4 screen
			if (this.arrayDisplayRatio4Vertical && this.arrayDisplayRatio4Vertical.length > 0) {
				if (row === 'row1') {
					const calculatewindow = window.innerHeight * this.arrayDisplayRatio4Vertical[0] / 100;
					previewHeight = calculatewindow;
				}
				if (row === 'row2') {
					const calculatewindow = window.innerHeight * this.arrayDisplayRatio4Vertical[1] / 100;
					previewHeight = calculatewindow;
				}
			}
			// 6 screen
			if (this.arrayDisplayRatio6Vertical && this.arrayDisplayRatio6Vertical.length > 0) {
				if (row === 'row1') {
					const calculatewindow = window.innerHeight * this.arrayDisplayRatio6Vertical[0] / 100;
					previewHeight = calculatewindow;
				}
				if (row === 'row2') {
					const calculatewindow = window.innerHeight * this.arrayDisplayRatio6Vertical[1] / 100;
					previewHeight = calculatewindow;
				}
			}
			// 9 screen
			if (this.arrayDisplayRatio9Vertical && this.arrayDisplayRatio9Vertical.length > 0) {
				if (row === 'row1') {
					const calculatewindow = window.innerHeight * this.arrayDisplayRatio9Vertical[0] / 100;
					previewHeight = calculatewindow;
				}
				if (row === 'row2') {
					const calculatewindow = window.innerHeight * this.arrayDisplayRatio9Vertical[1] / 100;
					previewHeight = calculatewindow;
				}
				if (row === 'row3') {
					const calculatewindow = window.innerHeight * this.arrayDisplayRatio9Vertical[2] / 100;
					previewHeight = calculatewindow;
				}
			}
			// width
			const widthAccordingToHeight = previewHeight / ratio;
			const style = {
				width: `${widthAccordingToHeight}px`,
				height: `${previewHeight}px`,
			};
			return style;
		},
		centerVertically(item, row, index) {
			let previewHeight = 0;
			let transformScale = 0;
			// width
			const defaultWidth = 1920;
			const displayWidth = item ? parseInt(item.displaySize.width) : defaultWidth;
			// height
			const defaultHeight = 1080;
			const displayHeight = item ? parseInt(item.displaySize.height) : defaultHeight;
			// 2 screen
			if (this.filteredItems && this.filteredItems.length === 2) {
				const calculatewindow = window.innerWidth * (this.arrayDisplayRatio2[index] ? this.arrayDisplayRatio2[index] : 50) / 100;
				transformScale = calculatewindow / displayWidth;
				previewHeight = window.innerHeight;
			}
			// 4 screen
			if (this.filteredDisplayRundown.length > 2 && this.filteredDisplayRundown.length <= 4) {
				if (row === 'row1') {
					const calculatewindowHeight = window.innerHeight * (this.arrayDisplayRatio4Vertical[0] ? this.arrayDisplayRatio4Vertical[0] : 50) / 100;
					const calculatewindowWidth = window.innerWidth * (this.arrayDisplayRatio4Horizontal[index] ? this.arrayDisplayRatio4Horizontal[index] : 50) / 100;
					transformScale = Math.min(calculatewindowWidth / displayWidth, calculatewindowHeight / displayHeight);
					previewHeight = calculatewindowHeight;
				}
				if (row === 'row2') {
					const calculatewindowHeight = window.innerHeight * (this.arrayDisplayRatio4Vertical[1] ? this.arrayDisplayRatio4Vertical[1] : 50) / 100;
					const calculatewindowWidth = window.innerWidth * (this.arrayDisplayRatio42Horizontal[index] ? this.arrayDisplayRatio42Horizontal[index] : 50) / 100;
					transformScale = Math.min(calculatewindowWidth / displayWidth, calculatewindowHeight / displayHeight);
					previewHeight = calculatewindowHeight;
				}
			}
			// 6 screen
			if (this.filteredDisplayRundown.length > 4 && this.filteredDisplayRundown.length <= 6) {
				if (row === 'row1') {
					const calculatewindowHeight = window.innerHeight * (this.arrayDisplayRatio6Vertical[0] ? this.arrayDisplayRatio6Vertical[0] : 33.3) / 100;
					const calculatewindowWidth = window.innerWidth * (this.arrayDisplayRatio6Horizontal[index] ? this.arrayDisplayRatio6Horizontal[index] : 33.3) / 100;
					transformScale = Math.min(calculatewindowWidth / displayWidth, calculatewindowHeight / displayHeight);
					previewHeight = calculatewindowHeight;
				}
				if (row === 'row2') {
					const calculatewindowHeight = window.innerHeight * (this.arrayDisplayRatio6Vertical[1] ? this.arrayDisplayRatio6Vertical[1] : 33.3) / 100;
					const calculatewindowWidth = window.innerWidth * (this.arrayDisplayRatio62Horizontal[index] ? this.arrayDisplayRatio62Horizontal[index] : 33.3) / 100;
					transformScale = Math.min(calculatewindowWidth / displayWidth, calculatewindowHeight / displayHeight);
					previewHeight = calculatewindowHeight;
				}
			}
			// 9 screen
			if (this.filteredDisplayRundown.length > 6 && this.filteredDisplayRundown.length <= 9) {
				if (row === 'row1') {
					const calculatewindowHeight = window.innerHeight * (this.arrayDisplayRatio9Vertical[0] ? this.arrayDisplayRatio9Vertical[0] : 33.3) / 100;
					const calculatewindowWidth = window.innerWidth * (this.arrayDisplayRatio9Horizontal[index] ? this.arrayDisplayRatio9Horizontal[index] : 33.3) / 100;
					transformScale = Math.min(calculatewindowWidth / displayWidth, calculatewindowHeight / displayHeight);
					previewHeight = calculatewindowHeight;
				}
				if (row === 'row2') {
					const calculatewindowHeight = window.innerHeight * (this.arrayDisplayRatio9Vertical[1] ? this.arrayDisplayRatio9Vertical[1] : 33.3) / 100;
					const calculatewindowWidth = window.innerWidth * (this.arrayDisplayRatio92Horizontal[index] ? this.arrayDisplayRatio92Horizontal[index] : 33.3) / 100;
					transformScale = Math.min(calculatewindowWidth / displayWidth, calculatewindowHeight / displayHeight);
					previewHeight = calculatewindowHeight;
				}
				if (row === 'row3') {
					const calculatewindowHeight = window.innerHeight * (this.arrayDisplayRatio9Vertical[2] ? this.arrayDisplayRatio9Vertical[2] : 33.3) / 100;
					const calculatewindowWidth = window.innerWidth * (this.arrayDisplayRatio93Horizontal[index] ? this.arrayDisplayRatio93Horizontal[index] : 33.3) / 100;
					transformScale = Math.min(calculatewindowWidth / displayWidth, calculatewindowHeight / displayHeight);
					previewHeight = calculatewindowHeight;
				}
			}
			const heightContent = (transformScale * displayHeight);
			return (previewHeight - heightContent) / 2;
		},
		filteredItems(firstLimit, endLimit) {
			const filtered = this.items.filter(item => item.rundown_id);
			return filtered.slice(firstLimit, endLimit);
		},
		// 2 screen
		onDragEnd2(size) {
			this.arrayDisplayRatio2 = size;
		},
		// 4 screen
		onDragEnd4Vertical(size) {
			this.arrayDisplayRatio4Vertical = size;
		},
		onDragEnd4Horizontal(size) {
			this.arrayDisplayRatio4Horizontal = size;
		},
		onDragEnd42Horizontal(size) {
			this.arrayDisplayRatio42Horizontal = size;
		},
		// 6 screen
		onDragEnd6Vertical(size) {
			this.arrayDisplayRatio6Vertical = size;
		},
		onDragEnd6Horizontal(size) {
			this.arrayDisplayRatio6Horizontal = size;
		},
		onDragEnd62Horizontal(size) {
			this.arrayDisplayRatio62Horizontal = size;
		},
		// 9 screen
		onDragEnd9Vertical(size) {
			this.arrayDisplayRatio9Vertical = size;
		},
		onDragEnd9Horizontal(size) {
			this.arrayDisplayRatio9Horizontal = size;
		},
		onDragEnd92Horizontal(size) {
			this.arrayDisplayRatio92Horizontal = size;
		},
		onDragEnd93Horizontal(size) {
			this.arrayDisplayRatio93Horizontal = size;
		},
		resetPane() {
			if (this.filteredDisplayRundown.length > 1 && this.filteredDisplayRundown.length <= 2) {
				this.arrayDisplayRatio2 = [50, 50];
				this.$refs.mySplit2.reset();
			}
			if (this.filteredDisplayRundown.length > 2 && this.filteredDisplayRundown.length <= 4) {
				this.$refs.mySplit4.reset();
				this.$refs.mySplit41.reset();
				this.$refs.mySplit42.reset();
				this.arrayDisplayRatio4Vertical = [50, 50];
				this.arrayDisplayRatio4Horizontal = [50, 50];
				this.arrayDisplayRatio42Horizontal = [50, 50];
			}
			if (this.filteredDisplayRundown.length > 4 && this.filteredDisplayRundown.length <= 6) {
				this.$refs.mySplit6.reset();
				this.$refs.mySplit61.reset();
				this.$refs.mySplit62.reset();
				this.arrayDisplayRatio6Vertical = [33.3, 33.3, 33.3];
				this.arrayDisplayRatio6Horizontal = [33.3, 33.3, 33.3];
				this.arrayDisplayRatio62Horizontal = [33.3, 33.3, 33.3];
			}
			if (this.filteredDisplayRundown.length > 6 && this.filteredDisplayRundown.length <= 9) {
				this.$refs.mySplit9.reset();
				this.$refs.mySplit91.reset();
				this.$refs.mySplit92.reset();
				this.$refs.mySplit93.reset();
				this.arrayDisplayRatio9Vertical = [33.3, 33.3, 33.3];
				this.arrayDisplayRatio9Horizontal = [33.3, 33.3, 33.3];
				this.arrayDisplayRatio92Horizontal = [33.3, 33.3, 33.3];
				this.arrayDisplayRatio93Horizontal = [33.3, 33.3, 33.3];
			}
		},
	},
	computed: {
		filteredDisplayRundown() {
			const filtered = this.items.filter(item => item.rundown_id);
			return filtered;
		},
		userId() {
			return this.$route.params.id;
		},
		ownMultipviewUserId() {
			const uniqueCode = atob(this.userId).split('=').pop();
			return uniqueCode;
		},
	},
	created() {
		this.setDrawerVisible(false);
		this.fetchDisplay(true);
	},
	mounted() {
		const element = document.getElementById('multipleDisplay');
		element.addEventListener('mousemove', () => {
			this.isShowButtonReset = true;
			clearTimeout(this.timer);
			this.timer = setTimeout(() => {
				this.isShowButtonReset = false;
			}, 4000);
		});
		element.addEventListener('mouseleave', () => {
			clearTimeout(this.timer);
			this.isShowButtonReset = false;
		});
	},
};
</script>
